import React from 'react';
import { formatDate } from '../../utils/helpers';
import { getPlainTextPreview } from '../../utils/htmlSanitizer';
import ContactButton from '../contact/ContactButton';
import LazyImage from '../common/LazyImage';

const PostCard = ({ post, onClick, showContactButton = false }) => {
  const handleCardClick = (e) => {
    // Don't trigger card click if contact button was clicked
    if (e.target.closest('[data-contact-button]')) {
      return;
    }
    if (onClick) {
      onClick();
    }
  };

  return (
    <article
      onClick={handleCardClick}
      className="bg-white rounded-xl shadow-sm border hover:shadow-md transition cursor-pointer overflow-hidden h-full flex flex-col"
    >
      {/* Image */}
      <div className="w-full h-48 bg-gray-100 overflow-hidden">
        {post.images && post.images.length > 0 ? (
          <LazyImage
            src={post.images[0].original_image}
            alt={post.title}
            className="w-full h-48"
            objectFit="cover"
            showProgress={true}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-gray-400">
            <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7a4 4 0 014-4h10a4 4 0 014 4v10a4 4 0 01-4 4H7a4 4 0 01-4-4V7z" />
            </svg>
          </div>
        )}
      </div>

      {/* Body */}
      <div className="p-4 flex flex-col h-full">
        {/* Content area that grows */}
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-gray-900 mb-2 line-clamp-2">{post.title}</h3>
          <p className="text-gray-500 text-sm line-clamp-3 mb-4">
            {getPlainTextPreview(post.content, 200)}
          </p>
        </div>

        {/* Fixed bottom section */}
        <div className="mt-auto">
          <div className="pt-3 border-t">
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center">
                <div className="w-7 h-7 rounded-full bg-gray-200 overflow-hidden mr-2 flex items-center justify-center">
                  {post.user_avatar ? (
                    <img src={post.user_avatar} alt={post.user_name || 'User'} className="w-full h-full object-cover" />
                  ) : (
                    <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                  )}
                </div>
                <span className="text-sm text-gray-700">{post.user_name || 'Author'}</span>
              </div>
              <span className="text-sm text-gray-500">{formatDate(post.created_at)}</span>
            </div>
            
            {/* Contact Button for Travel/Visa posts - Always at bottom */}
            {showContactButton && post.category === 'travel' && (
              <div className="flex justify-end" data-contact-button>
                <ContactButton
                  offer={post}
                  category={post.category}
                  buttonText={`Get ${post.category.charAt(0).toUpperCase() + post.category.slice(1)} Info`}
                  buttonStyle="primary"
                  className="text-sm"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </article>
  );
};

export default PostCard;


